import PropTypes from "prop-types";

// Spec 2026-09-23 §4: {bucket, lowerBound, upperBound?, pointEstimate?}.
// dataPoints is legacy-only (never emitted for ZoomInfo rows).
export let MetricPropTypes = PropTypes.shape({
  bucket: PropTypes.string,
  pointEstimate: PropTypes.number,
  upperBound: PropTypes.number,
  lowerBound: PropTypes.number,
  dataPoints: PropTypes.arrayOf(PropTypes.number)
})
